'use client';

import { useState } from 'react';
import Photo from '@components/elements/Photo';

/**
 * Trabajos del negocio: una fila de fotos verticales que se desliza y, con «Ver los N», todas en
 * grilla. Sin fotos, no aparece. Con `skipUrl`, la fila no repite la foto que ya está en la portada
 * (la grilla completa sí la incluye).
 */
export default function ProfileWorks({ photos, skipUrl = null, name }) {
  const [all, setAll] = useState(false);
  if (!photos?.length) return null;
  const count = photos.length;
  const shown = all || !skipUrl ? photos : photos.filter((p) => p.url !== skipUrl);

  return (
    <section className="pf-works" aria-labelledby="trabajos">
      <div className="pf-works__head">
        <h2 id="trabajos" className="pf-h2 font-display">
          Trabajos
        </h2>
        {count > 4 && (
          <button type="button" className="pf-works__more" onClick={() => setAll((v) => !v)} aria-expanded={all}>
            {all ? 'Ver menos' : `Ver los ${count} →`}
          </button>
        )}
      </div>
      <div className={`pf-works__row ${all ? 'is-all' : ''}`}>
        {shown.map((photo, i) => (
          <figure key={photo.url} className="pf-reel">
            <Photo
              src={photo.url}
              size={500}
              eager={i < 2}
              alt={photo.caption ? `${photo.caption}, de ${name}` : `Trabajo de ${name}`}
            />
            {photo.video && (
              <span className="pf-reel__play" aria-label="Video">
                <svg width="12" height="12" viewBox="0 0 20 20" fill="#ffffff" aria-hidden="true">
                  <path d="M6 4v12l10-6z" />
                </svg>
              </span>
            )}
            {photo.caption && <figcaption className="pf-reel__cap">{photo.caption}</figcaption>}
          </figure>
        ))}
      </div>
    </section>
  );
}
